import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../../../../services/transaksi/TransaksiService'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { FaSave } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import MasterService from '../../../../../services/master/MasterService'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalViewMutuArea = ({ showMutuArea, handleCloseMutuArea, nomorAju, dataArea, reloadList, isEdit }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let masterService = useMemo(() => new MasterService(), [])

    const [valueMutuAreaSeri, setValueMutuAreaSeri] = useState(null)
    const [valueMutuArea, setValueMutuArea] = useState(null)
    const onChangeArea = e => {
        setValueMutuArea(e)
    }
    const [valueMutuCultProp, setValueMutuCultProp] = useState(null)
    const [valueMutuCultKota, setValueMutuCultKota] = useState(null)
    const [valueMutuBudidayaNama, setValueMutuBudidayaNama] = useState(null)
    const onChangeMutuBudidayaNama = e => {
        setValueMutuBudidayaNama(e.target.value)
    }
    const [valueMutuBudidayaJenis, setValueMutuBudidayaJenis] = useState(null)
    const onChangeJenisBudidaya = e => {
        setValueMutuBudidayaJenis(e)
    }
    const [valueMutuTangkapArea, setValueMutuTangkapArea] = useState(null)
    const [valueMutuTangkapKapal, setValueMutuTangkapKapal] = useState(null)
    const onChangeTangkapKapal = e => {
        setValueMutuTangkapKapal(e.target.value)
    }
    const [valueMutuNoSertifikat, setValueMutuNoSertifikat] = useState(null)
    const onChangeMutuNomor = e => {
        setValueMutuNoSertifikat(e.target.value)
    }
    const optionsArea = [{ value: '1', label: 'Aqua Cultured / Area Cultured' }, { value: '2', label: 'Wild Caught / Area Tangkap' }, { value: '3', label: 'Import / Impor' }]
    const optionsJenisBudidaya = [{ value: '1', label: 'Pembenihan' }, { value: '2', label: 'Budidaya' }]

    const [valueNegaraOpt, setValueNegaraOpt] = useState(null)
    const loadOptionNegara = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeNegaraOpt = e => {
        setValueNegaraOpt(e)
    }

    async function loadOptionArea(params, loadedOption, { page }) {
        return {
            options: optionsArea
        }
    }
    async function loadOptionJenisBudidaya(params, loadedOption, { page }) {
        return {
            options: optionsJenisBudidaya
        }
    }
    const [keyForSecondSelect, setKeyForSecondSelect] = useState(0)
    const loadOptionProp = async (search, loadedOption, { page = 1 }) => {
        const response = await masterService.listPropinsi(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeProp = e => {
        setValueMutuCultProp(e)
        setKeyForSecondSelect(prevKey => prevKey + 1)
    }

    const loadOptionKotaByProp = async (search, loadOptionArea, { page = 1 }) => {
        const response = await masterService.listKota(valueMutuCultProp.kodePropinsi, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeKota = e => {
        setValueMutuCultKota(e)
    }

    async function loadOptionWpp(search, loadedOption, { page = 1 }) {
        const response = await masterService.listWpp(search, search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangeOptionWpp = e => {
        setValueMutuTangkapArea(e)
    }

    const fetchAllData = useCallback(async () => {
        if (!dataArea?.trPpkMutuAreaPK.nomorAju) {
            return
        }

        try {
            setValueMutuAreaSeri(dataArea.trPpkMutuAreaPK.mutuAreaSeri)
            setValueMutuArea(optionsArea.find(opt => opt.value === dataArea.mutuArea))

            const results = await Promise.allSettled([
                masterService.getPropinsiById(dataArea.mutuCultProp),
                masterService.getKotaById(dataArea.mutuCultKota),
                masterService.listWpp(dataArea.mutuTangkapArea, null, 0, 10),
                masterService.getNegaraById(dataArea.mutuNegaraAsal)
            ])

            const [resProp, resKota, resWpp, resNegara] = results
            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;

            setValueMutuCultProp(getData(resProp))
            setValueMutuCultKota(getData(resKota))
            setValueMutuTangkapArea(getData(resWpp))
            setValueNegaraOpt(getData(resNegara))
            setValueMutuBudidayaNama(dataArea.mutuBudidayaNama)
            setValueMutuBudidayaJenis(optionsJenisBudidaya.find(opt => opt.value === dataArea.mutuBudidayaJenis))
            setValueMutuTangkapKapal(dataArea.mutuTangkapKapal)
            setValueMutuNoSertifikat(dataArea.mutuNomorSertifikat)
        } catch (error) {

        }
    }, [dataArea, masterService])

    useEffect(() => {
        let isMounted = true;
        if (!dataArea) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataArea, fetchAllData])

    const handleClickClose = () => {
        setValueMutuAreaSeri('')
        setValueMutuArea(null)
        setValueMutuCultProp(null)
        setValueMutuCultKota(null)
        setValueMutuTangkapArea(null)
        setValueMutuBudidayaNama('')
        setValueMutuBudidayaJenis(null)
        setValueMutuTangkapKapal('')
        setValueMutuNoSertifikat('')
        setValueNegaraOpt(null)
        reloadList(1)
        handleCloseMutuArea()
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleShowConfirmSimpan = () => setShowConfirmSimpan(true)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            const resNextSeri = await transaksiService.nextSeri('mutuarea', nomorAju)
            let jsonArea = {
                ...dataArea,
                trPpkMutuAreaPK: {
                    nomorAju: nomorAju,
                    mutuAreaSeri: valueMutuAreaSeri !== null && valueMutuAreaSeri !== '' ? valueMutuAreaSeri : resNextSeri.data
                },
                mutuArea: valueMutuArea.value,
                mutuCultProp: valueMutuCultProp.kodePropinsi,
                mutuCultKota: valueMutuCultKota.kodeKota,
                mutuBudidayaJenis: valueMutuBudidayaJenis ? valueMutuBudidayaJenis.value : '',
                mutuBudidayaNama: valueMutuBudidayaNama ? valueMutuBudidayaNama : '',
                mutuTangkapArea: valueMutuTangkapArea ? valueMutuTangkapArea.wpp : '',
                mutuTangkapKapal: valueMutuTangkapKapal ? valueMutuTangkapKapal : '',
                mutuNomorSertifikat: valueMutuNoSertifikat ? valueMutuNoSertifikat : '',
                mutuNegaraAsal: valueNegaraOpt ? valueNegaraOpt.kodeNegara : ''
            }
            const response = await transaksiService.addPpmMutuArea(jsonArea)
            if (response.data.kode === '200') {
                setShowSimpanSuccess(true)
                setShowConfirmSimpan(false)
            } else {
                setShowSimpanFailed(true)
                setShowConfirmSimpan(false)
            }
        } catch (error) {
            setShowSimpanFailed(true)
            setShowConfirmSimpan(false)
        }
        setLoadingSave(false)
    }

    const handleClickSimpanSuccess = () => {
        setValueMutuAreaSeri('')
        setValueMutuArea(null)
        setValueMutuCultProp(null)
        setValueMutuCultKota(null)
        setValueMutuTangkapArea(null)
        setValueMutuBudidayaNama('')
        setValueMutuBudidayaJenis(null)
        setValueMutuTangkapKapal('')
        setValueMutuNoSertifikat('')
        setValueNegaraOpt(null)
        reloadList(1)
        setShowSimpanSuccess(false)
        handleCloseMutuArea()
    }

    const handleClickSimpanFailed = () => {
        setShowSimpanFailed(false)
    }

    return (
        <>
            <Modal
                show={showMutuArea}
                onHide={handleCloseMutuArea}
                backdrop='static'
                size='lg'
                centered
            >
                <Modal.Header><Modal.Title><h6>Data Sumber Produksi</h6></Modal.Title></Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Sumber <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="6">
                                        <AsyncPaginate
                                            loadOptions={loadOptionArea}
                                            value={valueMutuArea}
                                            getOptionLabel={(option) => option.label}
                                            getOptionValue={(option) => option.value}
                                            additional={{
                                                page: 0,
                                            }}
                                            onChange={onChangeArea}
                                            isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                        />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Propinsi <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="6">
                                        <AsyncPaginate
                                            loadOptions={loadOptionProp}
                                            value={valueMutuCultProp}
                                            getOptionLabel={(option) => option.uraianPropinsi}
                                            getOptionValue={(option) => option.kodePropinsi}
                                            additional={{
                                                page: 1
                                            }}
                                            onChange={onChangeProp}
                                            isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                        />
                                    </Col>
                                    <Col sm="4"><span><i>Diisi Propinsi Tempat Pemasukan Jika Sumber IMPOR</i></span></Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Kota <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="6">
                                        <AsyncPaginate
                                            key={keyForSecondSelect}
                                            loadOptions={loadOptionKotaByProp}
                                            value={valueMutuCultKota}
                                            getOptionLabel={(option) => option.uraianKota}
                                            getOptionValue={(option) => option.kodeKota}
                                            additional={{
                                                page: 1
                                            }}
                                            onChange={onChangeKota}
                                            isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                        />
                                    </Col>
                                    <Col sm="4"><span><i>Diisi Kota Tempat Pemasukan Jika Sumber IMPOR</i></span></Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>

                    {
                        valueMutuArea && valueMutuArea.value === '1' &&
                        <>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form>
                                        <Form.Group as={Row} className='form-group'>
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Budidaya <span className='text-danger'>*</span></Form.Label>
                                            <Col sm="10">
                                                <Form.Control as="textarea" placeholder="Nama Pembudidaya " className="form-control-sm" value={valueMutuBudidayaNama} onChange={onChangeMutuBudidayaNama} disabled={!isEdit} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form>
                                        <Form.Group as={Row} className='form-group'>
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Jenis Budidaya <span className='text-danger'>*</span></Form.Label>
                                            <Col sm="6">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionJenisBudidaya}
                                                    value={valueMutuBudidayaJenis}
                                                    getOptionLabel={(option) => option.label}
                                                    getOptionValue={(option) => option.value}
                                                    additional={{
                                                        page: 0,
                                                    }}
                                                    onChange={onChangeJenisBudidaya}
                                                    isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </>
                    }
                    {
                        valueMutuArea && valueMutuArea.value === '2' &&
                        <>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form>
                                        <Form.Group as={Row} className='form-group'>
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">WPP</Form.Label>
                                            <Col sm="10">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionWpp}
                                                    value={valueMutuTangkapArea}
                                                    getOptionLabel={(option) => option.wpp + ' - ' + option.wilayah}
                                                    getOptionValue={(option) => option.wpp}
                                                    additional={{
                                                        page: 1
                                                    }}
                                                    onChange={onChangeOptionWpp}
                                                    isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form>
                                        <Form.Group as={Row} className='form-group'>
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Kapal <span className='text-danger'>*</span></Form.Label>
                                            <Col sm="8">
                                                <Form.Control type="text" placeholder="Nama Kapal " className="form-control-sm" value={valueMutuTangkapKapal} onChange={onChangeTangkapKapal} disabled={!isEdit} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </>
                    }

                    {
                        valueMutuArea && valueMutuArea.value === '3' &&
                        <>
                            <div className='row'>
                                <div className='col-12'>
                                    <Form>
                                        <Form.Group as={Row} className='form-group'>
                                            <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara Asal<span className='text-danger'>*</span></Form.Label>
                                            <Col sm="6">
                                                <AsyncPaginate
                                                    loadOptions={loadOptionNegara}
                                                    value={valueNegaraOpt}
                                                    getOptionLabel={(option) => option.uraianNegara}
                                                    getOptionValue={(option) => option.kodeNegara}
                                                    additional={{
                                                        page: 1
                                                    }}
                                                    onChange={onChangeNegaraOpt}
                                                    isDisabled={localStorage.getItem('isEditStorage') === '0' ? true : false}
                                                />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </>
                    }

                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Sertifikat</Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Nomor Sertifikat" className="form-control-sm" value={valueMutuNoSertifikat} onChange={onChangeMutuNomor} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleShowConfirmSimpan()}><FaSave /> Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Data Sumber Produksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Sumber Berhasil"
                    onConfirm={handleClickSimpanSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Sumber Gagal"
                    onConfirm={handleClickSimpanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalViewMutuArea